module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\tContrats et supports\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container with-add"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("type de contrat")]), _vm._v(" "), _c('div', {
    staticClass: "start row"
  }, [_c('custom-select', {
    attrs: {
      "object": true,
      "getter": 'full_name',
      "items": _vm.contractTypeList,
      "solo": true
    },
    model: {
      value: (_vm.contractTypeToAdd),
      callback: function($$v) {
        _vm.contractTypeToAdd = $$v
      },
      expression: "contractTypeToAdd"
    }
  }), _vm._v(" "), (_vm.contractTypeToAdd && _vm.contractTypeToAdd.name !== 'Autre') ? _c('div', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addContract
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contractTypeToAdd && _vm.contractTypeToAdd.name === 'Autre') ? _c('div', {
    staticClass: "add-support row start"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "contract name"
    }
  }, [_vm._v("Nouveau contrat")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContract.name),
      expression: "newContract.name"
    }],
    attrs: {
      "type": "text",
      "name": "contract name"
    },
    domProps: {
      "value": (_vm.newContract.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newContract, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    attrs: {
      "for": "contract name"
    }
  }, [_vm._v("Numéro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContract.number),
      expression: "newContract.number"
    }],
    attrs: {
      "type": "text",
      "name": "contract name"
    },
    domProps: {
      "value": (_vm.newContract.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newContract, "number", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-input ctn-label"
  }, [_c('label', {
    staticClass: "active",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('custom-select', {
    attrs: {
      "items": _vm.operationTypeList
    },
    model: {
      value: (_vm.newContract.type),
      callback: function($$v) {
        _vm.$set(_vm.newContract, "type", $$v)
      },
      expression: "newContract.type"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-plus",
    on: {
      "click": _vm.addContractToContractList
    }
  }, [_c('span', {
    staticClass: "icon-form-plus"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ctn-contracts"
  }, _vm._l((_vm.contracts), function(contract, key) {
    return _c('div', {
      key: key,
      staticClass: "ctn-contract"
    }, [_c('div', {
      staticClass: "ctn-top row"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v(_vm._s(contract.ref.full_name))]), _vm._v(" "), (contract.supports.length === 0) ? _c('div', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.removeContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-close"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ctn-supports"
    }, [_c('div', {
      staticClass: "form-elem-container with-add"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("type de support")]), _vm._v(" "), _c('div', {
      staticClass: "row start"
    }, [_c('custom-select', {
      attrs: {
        "items": _vm.supportListOfContract(contract.ref.contract_products),
        "solo": true,
        "object": true,
        "getter": 'product.full_name'
      },
      model: {
        value: (contract.supportToAdd),
        callback: function($$v) {
          _vm.$set(contract, "supportToAdd", $$v)
        },
        expression: "contract.supportToAdd"
      }
    }), _vm._v(" "), (contract.supportToAdd.product.name !== 'Autre') ? _c('div', {
      staticClass: "btn-plus",
      on: {
        "click": function($event) {
          return _vm.addSupportToContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-plus"
    })]) : _vm._e()], 1)]), _vm._v(" "), (contract.supportToAdd.product.name === 'Autre') ? _c('div', {
      staticClass: "add-support row start"
    }, [_c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input ctn-label",
      class: {
        error: _vm.errors.has('nom du nouveau support')
      }
    }, [_c('label', {
      attrs: {
        "for": "nom du nouveau support"
      }
    }, [_vm._v("Nouveau support")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (contract.newSupport.name),
        expression: "contract.newSupport.name"
      }],
      attrs: {
        "type": "text",
        "name": "nom du nouveau support"
      },
      domProps: {
        "value": (contract.newSupport.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contract.newSupport, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "inputUI",
        rawName: "v-inputUI"
      }],
      staticClass: "ctn-input ctn-label"
    }, [_c('label', {
      attrs: {
        "for": "isin"
      }
    }, [_vm._v("ISIN")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contract.newSupport.isin),
        expression: "contract.newSupport.isin"
      }],
      attrs: {
        "type": "text",
        "name": "isin"
      },
      domProps: {
        "value": (contract.newSupport.isin)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contract.newSupport, "isin", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "btn-plus",
      on: {
        "click": function($event) {
          return _vm.addToSupportlistOfContract(key)
        }
      }
    }, [_c('span', {
      staticClass: "icon-form-plus"
    })])]) : _vm._e(), _vm._v(" "), (contract.supportToAdd.product.name === 'Autre') ? _c('div', {
      staticClass: "error-add-support error-message"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.errors.first('nom du nouveau support')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v("\n\t\t\t\t\t\tSupports associés\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.contracts[key].supports), function(support, keyt) {
      return _c('div', {
        staticClass: "ctn-support row start"
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(support.ref.full_name))]), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Contrat N°")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.contractNumber),
          expression: "support.contractNumber"
        }],
        attrs: {
          "type": "text",
          "name": "contract"
        },
        domProps: {
          "value": (support.contractNumber)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "contractNumber", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Pourcentage")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.percent),
          expression: "support.percent"
        }],
        attrs: {
          "type": "number",
          "min": "0",
          "max": "100",
          "step": "0.01",
          "name": "percent"
        },
        domProps: {
          "value": (support.percent)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "percent", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "tri-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Prix unitaire")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.price),
          expression: "support.price"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "price", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('custom-select', {
        attrs: {
          "items": _vm.currencyList
        },
        model: {
          value: (support.currency),
          callback: function($$v) {
            _vm.$set(support, "currency", $$v)
          },
          expression: "support.currency"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "duo-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Parts")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.part),
          expression: "support.part"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.part)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "part", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "tri-value row"
      }, [_c('label', {
        staticClass: "row",
        attrs: {
          "for": "value"
        }
      }, [_vm._v("Montant investi")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (support.amountInvested),
          expression: "support.amountInvested"
        }],
        attrs: {
          "type": "text",
          "name": "value"
        },
        domProps: {
          "value": (support.amountInvested)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(support, "amountInvested", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('custom-select', {
        attrs: {
          "items": _vm.currencyList
        },
        model: {
          value: (support.currency),
          callback: function($$v) {
            _vm.$set(support, "currency", $$v)
          },
          expression: "support.currency"
        }
      })], 1), _vm._v(" "), (!support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.addProductToMission(contract, support)
          }
        }
      }, [_vm._v("Ajouter")]) : _vm._e(), _vm._v(" "), (!support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.cancelProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Annuler")]) : _vm._e(), _vm._v(" "), (support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.editProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Editer")]) : _vm._e(), _vm._v(" "), (support.isAPI) ? _c('div', {
        staticClass: "btn small btn-gold",
        on: {
          "click": function($event) {
            return _vm.removeProductFromMission(contract, support)
          }
        }
      }, [_vm._v("Supprimer")]) : _vm._e()])
    }), _vm._v(" "), (_vm.contracts[key].supports.length === 0) ? _c('div', {
      staticClass: "no-support"
    }, [_vm._v("\n\t\t\t\t\t\tAucun support associé\n\t\t\t\t\t")]) : _vm._e()], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30ef7219"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/EditForm/ContractsAndSupports.vue
// module id = 1097
// module chunks = 0